<template>
    <button class="px-5 py-2 rounded-full bg-black text-white text-sm cursor-pointer" @click="handlerEmbeddedClosePDC">
        Valider et retourner à ma commande
    </button>
</template>

<script>
export default {
    name: "ButonReturnV2",
    methods:{
        handlerEmbeddedClosePDC(){
            $eventbus.$emit('close:all')

            if(window.parent?.V7){
                window.parent.V7.doAction({
                    actionName: 'embeddedClosePDC'
                });
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
